import { SVGIconProps } from '../types/svg';

export const Warning = (props: SVGIconProps) => (
    <svg width="65" height="65" viewBox="0 0 65 65" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path d="M32.2549 26.0721L32.884 37.3041" stroke="#FF8A02" strokeWidth="1.44" />
        <path d="M33.0772 40.7483L33.1671 42.3529" stroke="#FF8A02" strokeWidth="1.44" strokeLinecap="square" />
        <path
            d="M29.2984 17.8826C30.2978 15.9036 33.0648 15.7487 34.2789 17.6037L51.0438 43.2177C52.2579 45.0728 51.0086 47.5465 48.7951 47.6705L18.2302 49.3822C16.0167 49.5062 14.499 47.1874 15.4984 45.2084L29.2984 17.8826Z"
            stroke="#00354F"
            strokeWidth="1.44"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.4556 15.3704C16.7538 15.1334 17.1877 15.1829 17.4248 15.481L20.9131 19.8682C21.1502 20.1664 21.1007 20.6003 20.8025 20.8374C20.5044 21.0745 20.0705 21.0249 19.8334 20.7268L16.345 16.3396C16.1079 16.0414 16.1575 15.6075 16.4556 15.3704Z"
            fill="#278BE5"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M51.8319 24.6276C51.8232 25.0084 51.5074 25.3101 51.1266 25.3014L45.523 25.1734C45.1422 25.1647 44.8405 24.8489 44.8492 24.4681C44.8579 24.0873 45.1737 23.7856 45.5545 23.7943L51.1581 23.9223C51.5389 23.931 51.8406 24.2467 51.8319 24.6276Z"
            fill="#278BE5"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.7074 27.3229C10.6691 26.9439 10.9454 26.6057 11.3244 26.5674L17.8713 25.9065C18.2503 25.8683 18.5886 26.1445 18.6268 26.5235C18.6651 26.9025 18.3889 27.2408 18.0099 27.279L11.4629 27.9399C11.0839 27.9781 10.7457 27.7019 10.7074 27.3229Z"
            fill="#FF8A02"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M46.3277 12.5609C46.6434 12.7741 46.7265 13.2028 46.5133 13.5185L42.8305 18.9716C42.6173 19.2873 42.1886 19.3704 41.8729 19.1572C41.5572 18.944 41.4742 18.5153 41.6874 18.1996L45.3701 12.7465C45.5833 12.4308 46.012 12.3477 46.3277 12.5609Z"
            fill="#FF8A02"
        />
    </svg>
);
